import { IListarClientesParcelasAtraso } from "../../../../Interfaces/Cobranca/Serasa/Negativar";
import {
    IListarParcelasPositivar,
    ILstParcelasParaPositivacaoBody,
} from "../../../../Interfaces/Cobranca/Serasa/Positivar";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export function ListarClientesParcelasPositivarSerasaService(requestBody: {
    DS_CLIENTE: string;
    QUANTIDADE: number;
    PAGINA: number;
    DS_STATUS_PARCELA: string;
}) {
    return Service(
        Axios.post<IListarClientesParcelasAtraso>(
            `/serasa/positivacaoserasa/listarclientesparcelaspositivar`,
            requestBody
        )
    );
}

export function ListarClientesParcelasPositivarSerasaExportarExcelService(
    requestBody: {
        DS_CLIENTE: string;
        QUANTIDADE: number;
        PAGINA: number;
    },
    flExcel?: boolean
) {
    return Service(
        Axios.post<Blob>(
            `/serasa/positivacaoserasa/listarclientesparcelaspositivar?flExcel=${flExcel}`,
            requestBody,
            { responseType: "blob" }
        )
    );
}

export function ListarParcelasParaPositivacaoService(
    PAGINA: number,
    QUANTIDADE: number,
    requestBody: ILstParcelasParaPositivacaoBody
) {
    return Service(
        Axios.post<IListarParcelasPositivar>(
            `/serasa/positivacaoserasa/listarparcelasparapositivacao?PAGINA=${PAGINA}&QUANTIDADE=${QUANTIDADE}`,
            requestBody
        )
    );
}

export function ListarParcelasParaPositivacaoExportarExcelService(
    PAGINA: number,
    QUANTIDADE: number,
    requestBody: ILstParcelasParaPositivacaoBody,
    flExcel?: boolean
) {
    return Service(
        Axios.post<Blob>(
            `/serasa/positivacaoserasa/listarparcelasparapositivacao?PAGINA=${PAGINA}&QUANTIDADE=${QUANTIDADE}&flExcel=${flExcel}`,
            requestBody,
            { responseType: "blob" }
        )
    );
}

export function ExecutarPositivacaoSerasaService(
    dsMotivoPositivacao: string,
    requestBody: Array<number>
) {
    return Service(
        Axios.post(
            `/serasa/positivacaoserasa/executarbaixanegativacao?dsMotivoPositivacao=${dsMotivoPositivacao}`,
            requestBody
        )
    );
}
